import { timeAgo } from "../../../ForBrands/brandDealUtils";
import { mailtoFor } from "../coachUtils";

// Coach Mode · My Circle (Figma 04 · My Circle) helpers. Pure functions,
// tested in src/tests/coachCircleModel.test.js. The rows come from
// coach/circle/: kind athlete | guardian | agent | missing, with `action`
// "Message" only when the coach may email that person.

// Chips; each value is also the key of the payload's counts.
export const CIRCLE_FILTERS = [
  { value: "all", label: "Everyone" },
  { value: "athletes", label: "Athletes" },
  { value: "guardians", label: "Guardians" },
  { value: "agents", label: "Agents" },
];

const EMPTY_TEXT = {
  all: "Add players with your team code. Their guardians and agents appear here once the athletes add them to their Circle.",
  athletes: "No athletes from this roster are on CACHE yet.",
  guardians: "No guardians linked yet.",
  agents: "No agents linked yet.",
};

export const circleEmptyText = (filter) => EMPTY_TEXT[filter] || EMPTY_TEXT.all;

// Last contact cell: "2 days ago", else "Never" (muted). A Missing row shows
// the coach's last request to link a guardian instead.
export const lastContactLabel = (row, now = new Date()) => {
  if (row.kind === "missing") {
    return row.lastRequest ? { text: `Requested ${timeAgo(row.lastRequest, { now })}`, muted: false } : { text: "Not requested", muted: true };
  }
  return row.lastContact ? { text: timeAgo(row.lastContact, { now }), muted: false } : { text: "Never", muted: true };
};

// Who "Message group" reaches: everyone in view the coach may email, once.
export const groupRecipients = (rows) => [...new Set((rows || []).filter((r) => r.action === "Message" && r.email).map((r) => r.email.toLowerCase()))];

// The most people one "Message group" may log: GROUP_MESSAGE_MAX in
// backend users/coach_mode_views.py, which refuses a longer list.
export const GROUP_MESSAGE_MAX = 100;

const LOCKED_GROUP_TITLE = "Opens once CACHE verifies you as this team's coach";

// Whether "Message group" can open for `count` recipients, and its title:
// who it reaches, or why it is off.
export const groupButton = (count, { locked = false } = {}) => {
  if (locked) return { enabled: false, title: LOCKED_GROUP_TITLE };
  if (!count) return { enabled: false, title: "Nobody in this view shares an email" };
  if (count > GROUP_MESSAGE_MAX) return { enabled: false, title: `Filter to ${GROUP_MESSAGE_MAX} people or fewer to message them at once` };
  return { enabled: true, title: `Email ${count === 1 ? "1 person" : `${count} people`} in this view` };
};

const checkInSubject = (teamName) => `Checking in from ${teamName || "your coach"}`;

// The contact-log entry (coach/contact/) for a row's action. A link request
// goes to the athlete, who owns their Circle.
export const contactLogFor = (row) =>
  row.kind === "missing"
    ? { email: row.athleteEmail, name: row.linkedTo, kind: "request_link", athleteEmail: row.athleteEmail }
    : { email: row.email, name: row.name, kind: "message", athleteEmail: row.athleteEmail };

// The mail draft a row's action opens.
export const outreachDraft = (row, teamName) =>
  row.kind === "missing"
    ? mailtoFor({
        email: row.athleteEmail,
        subject: "Please add your parent or guardian to your CACHE Circle",
        body: "Hi,\n\nYour NIL deals need a parent or guardian to co-sign. Please open My Circle in CACHE and add them so we can move forward.\n\n",
      })
    : mailtoFor({ email: row.email, subject: checkInSubject(teamName) });

// "Message group": one draft with everyone in blind copy.
export const groupDraft = (emails, teamName) => mailtoFor({ bcc: emails, subject: checkInSubject(teamName) });
